export default {
  TermsEn: `
  <h3>T-PAY Service</h3>

  <p class="mt-2">
    By using T-PAY, payment will be collected on behalf of game
    providers/e-shops and the purchase amount will be placed on your
    mobile phone bill issued by your Mobile Carrier. If you have a
    contract with your Mobile Carrier the charge will appear on your
    monthly phone bill. If you are a prepaid customer, the purchase
    amount will be deducted from your airtime credit. The amount you
    can spend each month and the value of each transaction may be
    limited by your Mobile Carrier. Please see your Mobile Carrier’s
    website for additional terms of use.
  </p>

  <p>
    To access your transaction history login to
    <a href="https://self-manage.tpay.me">
      https://self-manage.tpay.me
    </a>
    using the username and password provided to you in the welcome SMS
    you received after your first purchase. In order to use T-PAY you
    must have a mobile phone with text messaging capabilities (a
    “Mobile Device”). In order to make Mobile Carrier purchases, your
    Mobile Carrier must be one of T-PAY participating operators. You
    are solely responsible for all charges related to use of your
    Mobile Device in conjunction with the Service. You must be at
    least 13 years old to use the Service. If you are 13 or older but
    under the age of 18, you should review these terms and conditions
    with your parent or guardian to make sure that you and your parent
    or guardian understand these terms and conditions and that your
    parent or guardian consents to your use of the Service under these
    terms and conditions.
  </p>

  <h3>Acknowledgements by You</h3>

  <p class="mt-2">
    You acknowledge that: (i) transactions initiated by you through
    the T-PAY are non-cancelable and may not be refunded ; (ii) you
    are solely liable for use and access to the T-PAY from any device
    once entering received confirmation code on mobile device with
    number you entered and that T-PAY shall have no liability to you
    or any third party for any unauthorized use or access of the T-PAY
    through your Mobile Device; (iii) the charges for Mobile Carrier
    Billing Purchases will be reflected in your Mobile Carrier bill,
    and that you are solely responsible for such charges; (iv) if
    T-PAY, a Mobile Carrier, determines not to accept a transaction
    you initiate through the T-PAY, the Mobile Carrier, and the
    Merchant shall not have any liability to you; and (vi) T-PAY does
    not have control of or liability for the items purchased or the
    delivery of the items purchased to you and shall not have any
    liability to you for any actions taken or charges applied by a
    Mobile Carrier or a Merchant with respect to the items purchased
    or for any failure of delivery of the items purchased. Please
    contact your merchant directly for such issues. The T-PAY,
    including all materials and all intellectual property rights
    therein, remains the property of T-PAY or its licensors or
    suppliers.
  </p>

  <h3>Representations</h3>

  <p class="mt-2">
    You represent that: (i) you will comply with all laws, rules and
    regulations, any Mobile Carrier requirements, and the requirements
    of your authorized payment provider applicable to your use of the
    T-PAY; (ii) there is no law or restriction barring you from using
    the Service; (iii) you own and/or are authorized to use the Mobile
    Device, authorized payment method, and Mobile Number in
    conjunction with the T-PAY; and (iv) you are solely responsible
    for use of your Mobile Device with the T-PAY and for use of and
    access to your Registered Account.
  </p>

  <h3>Financial Usage Restrictions</h3>

  <p class="mt-2">
    The user may only use T-PAY in such a way, that a balance of
    transactions is guaranteed by the payment date and that purchases
    are only made within an existing credit limit, of which the
    customer is aware. If a customer does not adhere to these
    financial usage restrictions T-PAY is eligible to claim
    compensation for the expenditure arising from the use of service.
  </p>

  <h3>User’s Duty of Care and Obligation to Co-operate</h3>

  <p class="mt-2">
    The entry of a mobile phone number must be carried out with care
    and its accuracy must be checked before confirmation. The user
    must ensure that no other person uses his mobile phone or SIM card
    to utilize the T-PAY payment method without his explicit
    permission. If the SIM card is stolen or misused a report must
    immediately be filed with the police.
  </p>

  <h3>User’s Payment Obligation</h3>

  <p class="mt-2">
    T-PAY is obligated by its contractual partners to secure and pay
    any payments arising from users’ deployment of T-PAY, which are
    immediately due. The respective mobile phone operator of user will
    include these costs, as well as any other arising expenses from
    mobile phone or SIM card usage, in the user’s invoice. The amount
    is payable once the network operator has sent the mobile user an
    invoice. With pre-paid cards the sum is instantly debited from the
    account. Objections to invoice line items must be lodged within
    the period stipulated by the network provider for objections to be
    made. T-PAY is not obligated to refund any payments made, if the
    claim is effective. The user must clarify any other complaints
    regarding its purchase, within his contractual relationship to the
    respective partner, directly with this company (see website
    imprint). In this case the user’s payment obligations remain
    unaffected.
  </p>

  <h3>Liability for claims arising from improper use</h3>

  <p class="mt-2">
    As soon as the loss of a mobile telephone or SIM card is indicated
    to T-PAY the owner is no longer responsible for any further
    liability claims arising from improper use of the SIM card which
    occur after this time. For any claims arising from improper use
    which are lodged before notification of the loss of the mobile
    phone or SIM card, the owner is only liable if he has grossly
    neglected his obligations (e.g. the loss was not reported
    immediately). In this case the owner bears the claims, arising
    from his breach of duty, in their entirety, providing T-PAY has
    fulfilled its obligations.
  </p>

  <h3>Refunds</h3>

  <p class="mt-2">
    All Payment Transactions processed through the processing Service
    are non-refundable to Buyer by T-PAY and are non-reversible by
    Buyer through the Processing Service. You may have additional
    refund or charge-back rights under your Payment Instrument issuer
    agreement or applicable state and federal laws. You should review
    your periodic statement received from the issuer of your Payment
    Instrument which will reflect all purchase transactions through
    the Processing Service
  </p>

  <h3>Third Party Fees</h3>

  <p class="mt-2">
    You are responsible for any fees charged by your
    telecommunications provider, Payment Instrument, Offer, or Reward
    Program Item issuer, merchant, or any other third party in
    connection with your use of T-PAY
  </p>

  <h3>Periodic Statements</h3>

  <p class="mt-2">
    You agree that we will not provide you with a separate periodic
    statement for your use of T-PAY. An electronic transaction history
    showing all transactions with T-PAY Account transactions in
    electronic format will be made available free of charge. You are
    responsible for reviewing the T-PAY Account transaction history
  </p>

  <h3>Limitations on Use of Services</h3>

  <p class="mt-2">
    Notwithstanding any limitations described elsewhere in this
    Agreement, we may establish general practices and limits
    concerning use of the Services, including without limitation
    individual or aggregate transaction limits on the amount or number
    of transactions during any specified time period(s). We reserve
    the right to change, suspend or discontinue any aspect of the
    Services at any time, including hours of operation or availability
    of the Services or any Service feature, without notice and without
    liability. We also reserve the right to impose limits on certain
    Service features or restrict access to some or all of the Services
    without notice and without liability. We may decline to process
    any transaction without prior notice to you.
  </p>

  <p>
    We may limit or suspend your use of one or more Services at any
    time, in our sole and absolute discretion. If we suspend your use
    of a Service, we will attempt to notify you by electronic mail.
    Suspension of your use of a Service will not affect your rights
    and obligations pursuant to these Terms of Service arising before
    or after such suspension or with respect to any non-terminated
    Services.
  </p>

  <h3>No Endorsement of Products</h3>

  <p class="mt-2">
    T-PAY do not represent or endorse, and shall not be responsible
    for:
  </p>

  <ol class="mb-5">
    <li>
      the reliability or performance of any Seller, merchant or Third
      Party Provider;
    </li>
    <li>
      the safety, quality, accuracy, reliability, integrity or
      legality of any Product, Offer or Reward Program Item;
    </li>
    <li>
      the truth or accuracy of the description of any Product, Offer,
      or Reward Program Item, or of any advice, opinion, offer,
      proposal, statement, data or other information (collectively,
      "Content") displayed or distributed, purchased or paid through
      the Service, or the Google Web Sites; or
    </li>
    <li>
      your ability to buy or redeem Products, Offers or Reward Program
      Items using the Services. T-PAY hereby disclaim any liability or
      responsibility for errors or omissions in any Content in the
      Services. T-PAY reserve the right, but shall have no
      responsibility, to edit, modify, refuse to post or remove any
      Content, in whole or in part, that in its sole and absolute
      discretion is objectionable, erroneous, illegal, fraudulent or
      otherwise in violation of these Terms of Service.
    </li>
  </ol>

  <h3>Availability of the Service</h3>

  <p class="mt-2">
    T-PAY works to ensure that the service is available 24 hours a
    day, 7 days a week. However, there will be occasions when your
    account may not be accessible and/or the payment Service will be
    interrupted for maintenance, upgrades and emergency repairs or due
    to failure of telecommunications links and equipment. You agree
    that T-PAY will not be liable to you for any unavailability,
    suspension or discontinuance of the payment Service. T-PAY
    reserves the right to refuse to provide the Service to you at any
    time for any reason without notice.
  </p>

  <h3>
    Disclaimer of Liability for Goods or Services Paid for Using T-PAY
  </h3>

  <p class="mt-2">
    We are not responsible for and do not have any liability for any
    goods or services purchased or paid for through the T-PAY Service,
    including if a product or a service you purchased is unsafe, is
    not delivered, breaks, is different than as represented, or
    otherwise does not meet your needs or expectations. If a problem
    arises with the product or service you purchased from a third
    party retailer (e.g., a merchant), you need to resolve your issue
    directly with the Merchant
  </p>

  <h3>DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY</h3>

  <p class="mt-2">
    YOU ACKNOWLEDGE AND AGREE THAT THE GOODS PURCHASED USING THE T-PAY
    ARE PROVIDED BY THIRD PARTIES AND NOT BY T-PAY, AND THAT T-PAY
    SHALL HAVE NO LIABILITY TO YOU WHATSOEVER REGARDING SUCH GOODS OR
    RELATED TO THE DELIVERY OF THE GOODS. THE CHECKOUT SERVICE
    PROVIDED BY T-PAY IS ON AN “AS IS” AND “AS AVAILABLE” BASIS. T-PAY
    MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR
    IMPLIED INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
    MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, AS TO THE
    OPERATION OF THE CHECKOUT SERVICE OR THE INFORMATION, CONTENT,
    MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR SERVICES INCLUDED ON
    OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE CHECKOUT SERVICE.
    YOU EXPRESSLY AGREE THAT YOUR USE OF THE CHECKOUT SERVICE IS AT
    YOUR SOLE RISK.
  </p>

  <p>
    T-PAY DOES NOT WARRANT THAT THE CHECKOUT SERVICE, OR ELECTRONIC
    COMMUNICATIONS SENT FROM T-PAY ARE FREE OF VIRUSES OR OTHER
    HARMFUL COMPONENTS. OPENMARKET WILL NOT BE LIABLE FOR ANY DAMAGES
    OF ANY KIND ARISING FROM THE USE OF THE T-PAY SERVICE OR FROM ANY
    INFORMATION, CONTENT, MATERIALS, PRODUCTS (INCLUDING SOFTWARE) OR
    SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH
    THE CHECKOUT SERVICE, INCLUDING, BUT NOT LIMITED TO DIRECT,
    INDIRECT, INCIDENTAL, PUNITIVE, AND CONSEQUENTIAL DAMAGES.
  </p>

  <h3>Indemnification</h3>

  <p class="mt-2">
    You agree to indemnify, defend and hold T-PAY its affiliated
    companies, and its respective officers, directors, employees,
    agents, successors and assigns harmless from and against all
    claims, liabilities, losses, expenses, damages, and costs,
    including but not limited to reasonable attorneys’ fees, resulting
    from (i) a violation or breach of these Terms by you, or (ii) any
    activity related to access to your use of your Registered Account
    or your Mobile Device (including but not limited to negligent or
    wrongful conduct) by you or any other person accessing or using
    your Registered Account or using the Checkout Service through your
    Mobile Device or with your Mobile Number.
  </p>

  <h3>Release of T-PAY</h3>

  <p class="mt-2">
    If you have a dispute with your Mobile Carrier or a Merchant, you
    hereby release T-PAY, its affiliates, and their respective
    officers, directors, employees, agents, successors and assigns
    from any and all claims, demands, liabilities, losses and damages
    of every kind and nature arising out of or in any way connected
    with such disputes.
  </p>

  <h3>Policies, Modifications, and Severability</h3>

  <p class="mt-2">
    We reserve the right to make changes to the payment Service,
    policies, and these Terms and Conditions at any time without
    notice. Your continued use of the Checkout Service after such
    amendment constitutes your acceptance of the amended terms and
    conditions. If you do not accept an amendment made to these Terms
    and Conditions, your sole and exclusive remedy is to close your
    Account. If any of these conditions shall be deemed invalid, void,
    or for any reason unenforceable, that condition shall be deemed
    severable and shall not affect the validity and enforceability of
    any remaining condition.
  </p>

  <h3>Contact</h3>

  <p class="mt-2">
    Please contact us if you have any questions regarding the Terms
    and Conditions.
  </p>

  <a href="mailto:support@tpaymobile.com"
    >support@tpaymobile.com
  </a>
  `,
  TermsFr: `
  <h3>Service T-PAY</h3>

  <p class="mt-2">
    En utilisant T-PAY, le paiement sera collecté au nom des
    fournisseurs de jeux/boutiques en ligne et le montant de l'achat
    sera placé sur votre facture de téléphone portable émise par votre
    opérateur de téléphonie mobile. Si vous avez un contrat avec votre
    opérateur de téléphonie mobile, les frais apparaîtront sur votre
    facture de téléphone mensuelle. Si vous êtes un client prépayé, le
    montant de l'achat sera déduit de votre crédit de temps d'antenne.
    Le montant que vous pouvez dépenser chaque mois et la valeur de
    chaque transaction peuvent être limités par votre opérateur
    mobile. S'il vous plaît voir votre mobile Site Web du transporteur
    pour des conditions d'utilisation supplémentaires.
  </p>

  <p>
    Pour accéder à l'historique de vos transactions, connectez-vous à
    <a href="https://self-manage.tpay.me">
      https://self-manage.tpay.me
    </a>
    en utilisant le nom d'utilisateur et mot de passe qui vous sont
    fournis dans le SMS de bienvenue que vous avez reçu après votre
    premier achat.
  </p>

  <p>
    Afin d'utiliser T-PAY, vous devez disposer d'un téléphone mobile
    avec des capacités de messagerie texte (un " appareil mobile ").
    Pour effectuer des achats auprès d'un opérateur de téléphonie
    mobile, votre opérateur de téléphonie mobile doit être l'un des
    opérateurs participants à T-PAY.
  </p>

  <p>
    Vous êtes seul responsable de tous les frais liés à l'utilisation
    de votre appareil mobile en conjonction avec le service. Vous
    devez avoir au moins 13 ans pour utiliser le Service. Si vous avez
    13 ans ou plus mais moins de 18 ans, vous devez revoir ces termes
    et conditions avec votre parent ou tuteur pour vous assurer que
    vous et votre parent ou tuteur comprennent ces termes et
    conditions et que votre parent ou tuteur consent à ce que vous
    utilisiez le Service selon ces termes et conditions.
  </p>

  <h3>Remerciements par vous</h3>

  <p class="mt-2">
    Vous reconnaissez que : (i) les transactions initiées par vous via
    le T-PAY ne sont pas annulables et ne peuvent pas être
    remboursées, (ii) vous êtes seul responsable de l'utilisation et
    de l'accès au T-PAY à partir de n'importe quel appareil une fois
    que vous avez saisi le code de confirmation reçu sur l'appareil
    mobile avec le numéro que vous avez entré et que T-PAY n'aura
    aucune responsabilité envers vous ou tout tiers pour toute
    utilisation ou accès non autorisé de T-PAY via votre appareil
    mobile ; (iii) les frais pour les achats facturés per l'opérateur
    mobile seront reflétés dans votre facture d'opérateur mobile, et
    que vous êtes seul responsable de ces frais (iv) si T-PAY, un
    opérateur mobile,décide de ne pas accepter une transaction que
    vous initiez par l'intermédiaire de T-PAY, l'opérateur de
    téléphonie mobile et le marchand n'auront aucune responsabilité
    envers vous ;et (vi) T-PAY n'a pas le contrôle ni la
    responsabilité des articles achetés ou la livraison des articles
    achetés pour vous et n'aura aucune responsabilité envers vous pour
    les actions prises ou les frais appliqués par un opérateur de
    téléphonie mobile ou un marchand en ce qui concerne les articles
    achetés ou pour tout défaut de livraison des articles achetés.
    Veuillez contacter directement votre marchand pour de tels
    problèmes. Le T-PAY y compris tous les matériaux et tous les
    droits de propriété intellectuelle y afférents, reste la propriété
    de T-PAY ou de ses concédants ou fournisseurs.
  </p>

  <h3>Représentations</h3>

  <p class="mt-2">
    Vous déclarez que : (i) vous vous conformerez à toutes les lois,
    règles et réglementations, toutes les exigences des opérateurs de
    téléphonie mobile, et les exigences de votre fournisseur de
    paiement autorisé applicables à votre utilisation de T-PAY ; (ii)
    aucune loi ou restriction ne vous empêche d'utiliser le Service ;
    (iii) vous possédez et/ou êtes autorisé à utiliser l'Appareil
    Mobile, la méthode de paiement autorisée, et numéro de mobile en
    conjonction avec le T-PAY ; et (iv) vous êtes seul responsable de
    l'utilisation de votre appareil mobile avec le T-PAY et de
    l'utilisation et de l'accès à votre compte enregistré.
  </p>

  <h3>Restrictions d'utilisation financière</h3>

  <p class="mt-2">
    L'utilisateur ne peut utiliser T-PAY que de manière à ce qu'un
    solde des transactions soit garanti à la date de paiement et que
    les achats ne soient effectués que dans le cadre d'une limite de
    crédit existante. dont le client a connaissance. Si un client ne
    respecte pas ces restrictions d'utilisation financière, T-PAY est
    en droit de réclamer une indemnisation pour les dépenses résultant
    de l'utilisation du service.
  </p>

  <p>
    Devoir de diligence et obligation de coopération de l'utilisateur
  </p>

  <p>
    Le numéro de téléphone portable doit être saisi avec soin et
    vérifiée avant confirmation, L'utilisateur doit s'assurer
    qu'aucune autre personne n'utilise son téléphone mobile ou sa
    carte SIM pour utiliser le mode de paiement T-PAY sans son
    autorisation explicite. Si la carte SIM est vole ou utilisé à
    mauvais escient, un rapport doit être immédiatement déposé auprès
    de la police.
  </p>

  <h3>Obligation de paiement de l'utilisateur</h3>

  <p class="mt-2">
    T-PAY est tenu par ses partenaires contractuels de sécuriser et de
    payer les paiements résultant du fait des utilisateurs.
    déploiement de T-PAY par les utilisateurs, qui sont immédiatement
    exigibles. L'opérateur de téléphonie mobile respectif de
    l'utilisateur inclura ces coûts, ainsi que toute autre dépense
    découlant de l'utilisation du téléphone mobile ou de la carte SIM,
    sur la facture de l'utilisateur. Le montant est payable une fois
    que l'opérateur du réseau a envoyé une facture à l'utilisateur
    mobile, Avec les cartes prépayées, la somme est immédiatement
    débitée du compte. Les objections aux postes de facturation
    doivent être déposées dans le délai imparti par le fournisseur de
    réseau pour que les objections soient faites, T-PAY n'est pas
    obligé de rembourser les paiements effectués, si la réclamation
    est effective. L'utilisateur doit clarifier toute autre plainte
    concernant son achat, dans le cadre de sa relation contractuelle
    avec le partenaire respectif,directement avec cette société (voir
    mentions légales du site). Dans ce cas, les obligations de
    paiement de l'utilisateur restent inchangées.
  </p>

  <h3>
    Responsabilité pour les réclamations résultant d'une utilisation
    inappropriée
  </h3>

  <p class="mt-2">
    Dès que la perte d'un téléphone mobile ou d'une carte SIM est
    signalée à T-PAY le propriétaire n'est plus responsable d'autres
    réclamations en responsabilité résultant d'une mauvaise
    utilisation de la carte SIM qui se produisent après cette période.
    Pour toute réclamation résultant d'une mauvaise utilisation qui
    est formulée avant la notification de la perte du téléphone
    portable ou de la carte SIM, le propriétaire n'est responsable que
    s'il a grossièrement négligé ses obligations ((par exemple, la
    perte n'a pas été signalée immédiatement) Dans ce cas, le
    propriétaire supporte les créances résultant de son manquement à
    ses obligations, dans leur intégralité, sous réserve que T-PAY ait
    rempli ses obligations.
  </p>

  <h3>Remboursements</h3>

  <p class="mt-2">
    Toutes les transactions de paiement traitées via le service de
    traitement ne sont pas remboursables à l'acheteur par T-PAY et
    sont irréversibles par l'acheteur via le service de traitement.
    Vous pouvez avoir des droits de remboursement ou de
    rétrofacturation supplémentaires en vertu de votre contrat
    d'émetteur de mode de paiement ou des lois étatiques et fédérales
    applicables. Vous devez examiner votre relevé périodique reçu de
    l'émetteur de votre instrument de paiement, qui reflétera toutes
    les transactions d'achat via le service de traitement.
  </p>

  <h3>Frais de tiers</h3>

  <p class="mt-2">
    Vous êtes responsable de tous les frais facturés par votre
    fournisseur de telecommunications, Instrument de paiement, Offre
    ou émetteur d'articles du programme de récompenses, marchand ou
    tout autre tiers en relation avec votre utilisation de T-PAY
  </p>

  <h3>Relevés périodiques</h3>

  <p class="mt-2">
    Vous acceptez que nous ne vous fournirons pas de relevé périodique
    séparé pour votre utilisation de T-PAY. Un historique des
    transactions électroniques montrant toutes les transactions avec
    les transactions du compte T-PAY au format électronique sera mis à
    disposition gratuitement ,Vous êtes responsable de l'examen de
    l'historique des transactions du compte T-PAY
  </p>

  <h3>Limitations d'utilisation des services</h3>

  <p class="mt-2">
    Nonobstant toute limitation décrite ailleurs dans le présent
    Contrat, nous pouvons établir des pratiques générales et des
    limites concernant l'utilisation des Services, y compris, sans s'y
    limiter, les limites de transaction individuelles ou globales sur
    le montant ou le nombre de transactions au cours de toute période
    de temps spécifiée. nous réservons le droit de changer,suspendre
    ou interrompre tout aspect des Services à tout moment, y compris
    les heures d'ouverture ou la disponibilité des Services ou de
    toute fonctionnalité du Service, sans préavis et sans
    responsabilité, Nous réservons également le droit d'imposer des
    limites à certaines fonctionnalités du Service ou de restreindre
    l'accès à certaines ou tous les Services sans préavis et sans
    responsabilité. Nous pouvons refuser de traiter toute transaction
    sans préavis.
  </p>

  <p class="mt-2">
    Nous pouvons limiter ou suspendre votre utilisation d'un ou
    plusieurs Services à tout moment, à notre seule et absolue
    discretion, Si nous suspendons votre utilisation d'un Service,
    nous essaierons de vous en informer par courrier électronique, La
    suspension de votre utilisation d'un Service n'affectera pas vos
    droits et obligations en vertu des présentes Conditions
    d'utilisation survenant avant ou après une telle suspension, ou à
    l'égard de tout service non résilié.
  </p>

  <h3>Aucune approbation de produits</h3>

  <p class="mt-2">
    T-PAY ne représente ni n'approuve, et ne sera pas responsable de :
  </p>

  <ol class="mb-5" type="a">
    <li>
      la fiabilité ou les performances de tout vendeur, commerçant ou
      fournisseur tiers ;
    </li>
    <li>
      la sécurité, la qualité, l'exactitude, la fiabilité, l'intégrité
      ou la légalité de tout produit, offre ou élément du programme de
      récompense ;
    </li>
    <li>
      la véracité ou l'exactitude de la description de tout Produit,
      offre ou élément du programme de récompenses, ou de tout
      conseil, opinion, offre, proposition, déclaration, donnée ou
      autre information (collectivement, le "contenu") affichées ou
      distribuées , acheté ou payés via le Service ou les sites Web de
      Google ; ou
    </li>
    <li>
      votre capacité à acheter ou à échanger des Produits, Offres ou
      des Éléments du Programme de récompense en utilisant les
      Services. T-PAY décline par la présente toute responsabilité en
      cas d'erreurs ou d'omissions dans tout contenu des services.
      T-PAY se réserve le droit, mais n’a aucune responsabilité,
      d'éditer, de modifier, de refuser d’afficher ou de supprimer
      tout Contenu, en tout ou en partie, qui, à sa seule et absolue
      discrétion, est répréhensible, erroné, illégal, frauduleux ou
      autrement violation des présentes conditions d'utilisation.
    </li>
  </ol>

  <h3>Disponibilité du Service</h3>

  <p class="mt-2">
    T-PAY veille à ce que le service soit disponible 24 heures sur 24,
    7 jours sur 7. Toutefois, il se peut que votre compte ne soit pas
    accessible et/ou que le service de paiement soit interrompu pour
    maintenance, mises à niveau et réparations d'urgence. ou en raison
    d'une défaillance des liaisons de telecommunications et de
    l’équipement. Vous acceptez que T-PAY ne sera pas responsable
    envers vous de toute indisponibilité, suspension ou interruption
    du Service de paiement. T-PAY se réserve le droit de refuser de
    vous fournir le Service à tout moment pour quelque raison que ce
    soit et sans préavis.
  </p>

  <p>
    Exonération de responsabilité pour les biens ou services payés
    pour l'utilisation de T-PAY Nous ne sommes pas responsables et
    n'assumons aucune responsabilité pour les biens ou services
    achetés ou payés via le service T-PAY, y compris si un produit ou
    un service que vous avez acheté est dangereux, n'est pas livré, se
    brise, est différent de ce qui est représenté, ou ne répond pas à
    vos besoins ou à vos attentes. . Si un problème survient avec le
    produit ou le service que vous avez acheté auprès d'un détaillant
    tiers (p. ex., un commerçant), vous devez résoudre votre problème
    directement avec le commerçant.
  </p>

  <h3>EXCLUSION DE GARANTIES ET LIMITATION DE RESPONSABILITÉ</h3>

  <p class="mt-2">
    VOUS RECONNAISSEZ ET ACCEPTEZ QUE LES MARCHANDISES ACHETES VIA
    T-PAY SONT FOURNIES PAR DES TIERS ET NON PAR T-PAY, ET QUE T-PAY
    N’EST AUCUNEMENT RESPONSABLE ENVERS VOUS EN CE QUI CONCERNE CES
    MARCHANDISES OU QUI SONT LIÉES À LA LIVRAISON DES MARCHANDISES LE
    SERVICE DE CAISSE FOURNI PAR T-PAY EST « TEL QUEL » ET « TEL QUE
    DISPONIBLE ».T-PAY NE FAIT AUCUNE DÉCLARATION OU GARANTIE D'AUCUNE
    SORTE, EXPRESSE OU IMPLICITE, Y COMPRIS, MAIS SANS S'Y LIMITER,
    LES GARANTIES IMPLICITES DE QUALITÉ MARCHANDE ET D'ADÉQUATION À UN
    USAGE PARTICULIER , QUANT AU FONCTIONNEMENT DU SERVICE DE CHECKOUT
    OU DES INFORMATIONS, DU CONTENU, DES MATÉRIAUX, DES PRODUITS (Y
    COMPRIS LES LOGICIELS) OU DES SERVICES INCLUS DANS LE SERVICE DE
    CHECKOUT OU MIS À VOTRE DISPOSITION.
  </p>

  <p>
    VOUS CONVENEZ EXPRESSÉMENT QUE VOTRE UTILISATION DU SERVICE DE
    CAISSE EST À VOS PROPRES RISQUES.
  </p>

  <p>
    T-PAY NE GARANTIT PAS QUE LE SERVICE DE CHECKOUT OU LES
    COMMUNICATIONS ÉLECTRONIQUES ENVOYÉES PAR T-PAY SONT EXEMPTS DE
    VIRUS OU D'AUTRES COMPOSANTS NUISIBLES. OPENMARKET NE SERA PAS
    RESPONSABLE DE TOUT DOMMAGE DE QUELQUE NATURE QUE CE SOIT
    RÉSULTANT DE L'UTILISATION DU À PARTIR DE TOUTE INFORMATION,
    CONTENU, MATÉRIAUX, PRODUITS (Y COMPRIS LES LOGICIELS) OU SERVICES
    INCLUS OU MIS À VOTRE DISPOSITION PAR LE BIAIS DU SERVICE DE
    COMMANDE, Y COMPRIS, MAIS SANS S'Y LIMITER, LES DOMMAGES DIRECTS,
    INDIRECTS, ACCESSOIRES, PUNITIFS ET CONSÉCUTIFS.
  </p>

  <h3>Indemnisation</h3>

  <p class="mt-2">
    Vous acceptez d'indemniser, de défendre et de tenir T-PAY ses
    sociétés affiliées et ses dirigeants, administrateurs, employés,
    agents, successeurs et ayants droit respectifs indemnes de et
    contre toutes réclamations, responsabilités, pertes, dépenses,
    dommages et coûts, y compris mais non limité à des honoraires
    d'avocat raisonnables, résultant (i) d'une violation ou d'une
    violation des présentes conditions par vous,, ou (ii) de toute
    activité liée à l'accès à votre utilisation de votre Compte
    enregistré ou de votre Appareil mobile(y compris, mais sans s'y
    limiter, la négligence ou conduite fautive) par vous ou toute
    autre personne accédant ou utilisant votre compte enregistré ou
    utilisant le service de paiement via votre appareil mobile ou avec
    votre numéro de mobile.
  </p>

  <h3>Libération de T-PAY</h3>

  <p class="mt-2">
    Si vous avez un différend avec votre transporteur mobile ou un
    commerçant, vous dégagez par la présente T-PAY, ses sociétés
    affiliées et leurs dirigeants, administrateurs, employés, agents,
    successeurs et ayants droit respectifs de toute réclamation,
    demande, responsabilité, perte et dommage de toute sorte et de
    toute nature découlant de ou liés de quelque manière que ce soit à
    de tels différends.
  </p>

  <h3>Politiques, modifications et divisibilité</h3>

  <p class="mt-2">
    Nous nous réservons le droit d'apporter des modifications au
    service de paiement, aux politiques et aux présentes conditions
    générales à tout moment et sans préavis. Votre utilisation
    continue du service de paiement après une telle modification
    constitue votre acceptation des conditions générales modifiées. Si
    vous n'acceptez pas une modification apportée aux présentes
    conditions générales, votre seul et unique recours consiste à
    fermer votre compte. Si l'une de ces conditions est jugée
    invalide, nulle ou inapplicable pour toute raison inexécutable,
    cette condition sera réputée divisible et n'affectera pas la
    validité et l'applicabilité de toute condition restante.
  </p>

  <h3>Contact</h3>

  <p class="mt-2">
    Veuillez nous contacter si vous avez des questions concernant les
    Termes et Conditions.
  </p>

  <a href="mailto:support@tpaymobile.com">
    support@tpaymobile.com
  </a>
  `,
  TermsAr: `
  <h3>خدمة تي باي</h3>

  <p class="mt-2">
    باستخدام تي باي، سيتم تحصيل المدفوعات نيابة عن مزودي خدمة الألعاب
    / المتاجر الإلكترونية وسيتم إدراج مبلغ الشراء في فاتورة هاتفك
    المحمول الصادرة عن شركات الهاتف المحمول الخاصة بك. إذا كان لديك
    عقد مع شركة الهاتف المحمول، فستظهر الرسوم في فاتورة هاتفك الشهرية.
    إذا كنت من عملاء الدفع المسبق، سيتم خصم مبلغ الشراء من رصيدك. يجوز
    تحديد المبلغ الذي يمكنك إنفاقه كل شهر وكذلك قيمة كل معاملة من قبل
    شركة الهاتف المحمول الخاصة بك. يرجى زيارة الموقع الإلكتروني لشركة
    الهاتف المحمول الخاصة بك لمعرفة شروط الاستخدام الإضافية.
  </p>

  <p>
    للوصول إلى سجل المعاملات الخاصة بك، قم بتسجيل الدخول على الرابط
    التالي:
    <a href="https://self-manage.tpay.me">
      https://self-manage.tpay.me
    </a>
    باستخدام اسم المستخدم وكلمة المرور المقدمين لك في رسالة الترحيب
    القصيرة التي تلقيتها عقب إجرائك عملية الشراء الأولى.
  </p>

  <p>
    لاستخدام تي باي، يجب أن يكون لديك هاتف محمول مزود بإمكانيات
    المراسلة النصية ("جهاز الهاتف المحمول"). لإجراء عمليات شراء من
    خلال شركة الهاتف المحمول، يجب أن تكون شركة الهاتف المحمول واحدة من
    المشغلين المشاركين في تي باي.
  </p>

  <p>
    أنت مسؤول بمفردك عن جميع الرسوم المتعلقة باستخدام هاتفك المحمول
    بالتزامن مع الخدمة. يجب أن يكون عمرك 13 عاما على الأقل لاستخدام
    الخدمة. إذا كان عمرك 13 عاما أو أكثر ولكنك أقل من 18 عاما، فيتعين
    عليك الاطلاع على هذه الشروط والأحكام مع والديك أو الوصي عليك
    للتأكد من فهمك وكذلك فهم والديك أو الوصي عليك لهذه الشروط والأحكام
    وأن والديك أو الوصي عليك يوافق على استخدامك للخدمة بموجب هذه
    الشروط والأحكام.
  </p>

  <h3>إقرارات من جانبك</h3>

  <p class="mt-2">
    يجب أن تقر بما يلي: (1) المعاملات التي بدأتها بها من خلال تي باي
    غير قابلة للإلغاء ولا يجوز استرداد قيمتها؛ (2) أنت مسؤول بمفردك عن
    استخدام تي باي والوصول إليها من أي جهاز بمجرد إدخال رمز التأكيد
    المستلم على جهاز الهاتف المحمول الذي يحتوي على الرقم الذي أدخلته،
    ولن تتحمل تي باي أي مسؤولية تجاهك أو تجاه أي طرف ثالث عن أي
    استخدام غير مصرح به أو الوصول إلى تي باي من خلال جهاز الهاتف
    المحمول الخاص بك؛ (3) سيتم إدراج رسوم المشتريات من خلال شركة
    الهاتف المحمول في فاتورة شركة الهاتف المحمول الخاصة بك، وستكون
    المسؤول الوحيد عن هذه الرسوم؛ (4) إذا قررت تي باي، وهي شركة من
    شركات الهاتف المحمول، عدم قبول أي معاملة بدأتها من خلال تي باي ،
    فلن تتحمل شركة الهاتف المحمول والتاجر أي مسؤولية تجاهك؛ و(5) لا
    تتحكم تي باي أو تتحمل مسؤولية عن العناصر المشتراة أو تسليم العناصر
    المشتراة إليك، ولن تتحمل أي مسؤولية تجاهك عن أي إجراءات تم اتخاذها
    أو رسوم تم تطبيقها من قبل شركة الهاتف المحمول أو التاجر فيما يتعلق
    بالعناصر المشتراة أو أي إخفاق في تسليم العناصر المشتراة. يرجى
    الاتصال بالتاجر مباشرة في حالة وقوع مثل هذه الأمور. تظل تي باي،
    بما في ذلك جميع المواد وجميع حقوق الملكية الفكرية المتعلقة بها،
    ملكا لتي باي أو المرخصين أو الموردين التابعين لها.
  </p>

  <h3>الإقرارات</h3>

  <p class="mt-2">
    يجب أن تقر بما يلي: (1) أنك ستمتثل إلى جميع القوانين والقواعد
    واللوائح وكذلك أي متطلبات خاصة بشركة الهاتف المحمول ومتطلبات مزود
    خدمة الدفع المعتمد الخاص بك والتي يتم تطبيقها على استخدامك لخدمة
    تي باي؛ (2) لا يوجد قانون أو قيود تمنعك من استخدام الخدمة؛ (3) أنك
    تمتلك و / أو مصرح لك باستخدام جهاز الهاتف المحمول وطريقة السداد
    المصرح بها ورقم الهاتف المحمول بالاشتراك مع خدمة تي باي؛ و(4) أنك
    المسؤول الوحيد عن استخدام جهاز هاتفك المحمول فيما يتعلق بخدمة تي
    باي واستخدام حسابك المسجل والوصول إليه.
  </p>

  <h3>قيود الاستخدام المالي</h3>

  <p class="mt-2">
    لا يجوز للمستخدم استخدام خدمة تي باي إلا بهذه الطريقة؛ بحيث يتم
    ضمان رصيد المعاملات بحلول تاريخ السداد وأن عمليات الشراء تتم فقط
    وفقا للحد الائتماني الموجود والذي يعرفه العميل. إذا لم يلتزم
    العميل بقيود الاستخدام المالي هذه، تكون تي باي مؤهلة للمطالبة
    بالتعويض عن النفقات الناشئة عن استخدام الخدمة.
  </p>

  <h3>واجب الرعاية والالتزام بالتعاون من قبل المستخدم</h3>

  <p class="mt-2">
    يجب إدخال رقم الهاتف المحمول بعناية ويجب التحقق من دقته قبل
    التأكيد. يجب على المستخدم التأكد من عدم استخدام أي شخص آخر لهاتفه
    المحمول أو شريحة الهاتف الخاصة به لاستخدام طريقة تي باي للسداد
    بدون إذن صريح منه. في حالة سرقة شريحة الهاتف أو إساءة استخدامها،
    يتعين إبلاغ الشرطة على الفور.
  </p>

  <h3>التزام السداد من قبل المستخدم</h3>
  <p class="mt-2">
    تلتزم تي باي من قبل شركائها التعاقديين بتأمين وسداد أية مدفوعات
    ناشئة عن نشر المستخدمين لخدمة تي باي والتي تكون مستحقة على الفور.
    سيقوم مشغل الهاتف المحمول الخاص بالمستخدم بإدراج هذه التكاليف
    وكذلك أي نفقات أخرى ناشئة عن استخدام الهاتف المحمول أو شريحة
    الهاتف في فاتورة المستخدم. يكون المبلغ مستحقا بمجرد قيام مشغل
    الشبكة بإرسال فاتورة لمستخدم الهاتف المحمول. باستخدام البطاقات
    المدفوعة مسبقا، يتم خصم المبلغ على الفور من الحساب. يجب تقديم
    الاعتراضات على بنود الفاتورة خلال الفترة التي يحددها مزود الشبكة
    لتقديم الاعتراضات. تي باي غير ملزمة برد أية مدفوعات إذا كانت
    المطالبة فعالة. يتعين على المستخدم توضيح أية شكاوى أخرى بخصوص
    عملية الشراء الخاصة به، وفقا لعلاقته التعاقدية مع الشريك المعني،
    بشكل مباشر مع هذه الشركة (راجع خاتم الموقع الإلكتروني). في هذه
    الحالة، تظل التزامات السداد الخاصة بالمستخدم كما هي.
  </p>

  <h3>المسؤولية عن المطالبات الناشئة عن الاستخدام الغير صحيح</h3>
  <p class="mt-2">
    بمجرد إبلاغ تي باي بفقدان الهاتف المحمول أو شريحة الهاتف، لا يعد
    المالك مسؤولا عن أية مطالبات أخرى ناشئة عن الاستخدام الغير صحيح
    لشريحة الهاتف والتي تحدث بعد هذا الوقت. بالنسبة لأية مطالبات ناشئة
    عن الاستخدام الغير صحيح والتي يتم تقديمها قبل الإخطار بفقدان
    الهاتف المحمول أو شريحة الهاتف، يكون المالك مسؤولا فقط في حالة
    إهماله الالتزامات الخاصة به بشكل جسيم (على سبيل المثال، عدم
    الإبلاغ عن الفقدان على الفور). في هذه الحالة، يتحمل المالك
    المطالبات الناشئة عن خرقه للواجب، في مجملها، شريطة أن تكون تي باي
    قد أوفت بالتزاماتها.
  </p>

  <h3>المبالغ المستردة</h3>
  <p class="mt-2">
    جميع معاملات السداد التي تتم معالجتها من خلال خدمة المعالجة تكون
    غير قابلة للاسترداد للمشتري من قبل تي باي، ولا يمكن للمشتري
    التراجع عنها من خلال خدمة المعالجة. قد تكون مستحقا لحقوق استرداد
    أو رد إضافية بموجب اتفاقية مُصدر أداة الدفع أو قوانين الدولة
    والقوانين الفيدرالية المعمول بها. يتعين عليك مراجعة كشف حسابك
    الدوري المستلم من مُصدر أداة الدفع الخاصة بك والذي سيتضمن جميع
    معاملات الشراء من خلال خدمة المعالجة.
  </p>

  <h3>رسوم الطرف الثالث</h3>
  <p class="mt-2">
    أنت مسؤول عن أي رسوم يتم تحميلها من قبل مزود خدمة الاتصالات أو
    أداة الدفع أو العرض أو مُصدر عنصر برنامج المكافآت أو التاجر أو أي
    طرف ثالث آخر فيما يتعلق باستخدامك لخدمة تي باي.
  </p>

  <h3>البيانات الدورية</h3>
  <p class="mt-2">
    أنت توافق على أننا لن نرسل لك بيانات دورية منفصلة لاستخدامك لخدمة
    تي باي. بشكل مجاني، سيتم إتاحة سجل المعاملات الإلكترونية الذي يعرض
    جميع المعاملات مع معاملات حساب تي باي بشكل إلكتروني. أنت مسؤول عن
    مراجعة سجل معاملات حساب تي باي.
  </p>

  <h3>القيود المفروضة على استخدام الخدمات</h3>
  <p class="mt-2">
    بغض النظر عن أي قيود موضحة في أي موضع آخر في هذه الاتفاقية، يجوز
    لنا وضع ممارسات وحدود عامة فيما يتعلق باستخدام الخدمات، بما في ذلك
    - على سبيل المثال لا الحصر - حدود المعاملات الفردية أو الإجمالية
    على مقدار أو عدد المعاملات خلال أي فترة / فترات زمنية محددة. نحتفظ
    بالحق في تغيير أو تعليق أو إيقاف أي جانب من جوانب الخدمات في أي
    وقت، بما في ذلك ساعات العمل أو توفر الخدمات أو أي ميزة من ميزات
    الخدمة، دون إرسال إشعار وبدون مسؤولية. نحتفظ أيضا بالحق في فرض
    قيود على خصائص خدمة معينة أو تقييد إمكانية الوصول إلى بعض الخدمات
    أو كلها بدون إشعار وبدون مسؤولية. يجوز لنا رفض معالجة أي معاملة
    بدون إرسال إشعار مسبق لك.
  </p>

  <p>
    يجوز لنا تقييد أو تعليق استخدامك لخدمة ما أو أكثر في أي وقت، وفقا
    لتقديرنا الخاص والمطلق. في حالة قيامنا بتعليق استخدامك للخدمة،
    سنحاول إخطارك بالبريد الإلكتروني. لن يؤثر تعليق استخدامك للخدمة
    على حقوقك والتزاماتك وفقا لشروط الخدمة هذه الناشئة قبل أو بعد هذا
    التعليق أو فيما يتعلق بأي خدمات لم يتم إنهاؤها.
  </p>

  <h3>لا يوجد تصديق على المنتجات</h3>
  <p class="mt-2">
    لا تقوم تي باي بإقرار أو التصديق على ما يلي ولا تكون مسؤولة عنه:
  </p>

  <ol class="mb-5 mr-4" type="a">
    <li class="my-2">
      ‌ موثوقية أو أداء أي بائع أو تاجر أو مزود خارجي؛
    </li>
    <li class="my-2">
      أمان أو جودة أو دقة أو موثوقية أو نزاهة أو قانونية أي منتج أو
      عرض أو عنصر من عناصر برنامج المكافآت؛
    </li>
    <li class="my-2">
      ‌ حقيقة أو دقة وصف أي منتج أو عرض أو عنصر من عناصر برنامج
      المكافآت، أو أي نصيحة أو رأي أو عرض أو اقتراح أو بيان أو بيانات
      أو معلومات أخرى (يشار إليها بشكل جماعي باسم "المحتوى") معروضة أو
      تم توزيعها أو شرائها أو سداد مقابلها من خلال الخدمة أو المواقع
      الإجمالية الخاصة بجوجل؛ أو
    </li>
    <li class="my-2">
      ‌ قدرتك على شراء أو استرداد المنتجات أو العروض أو عناصر برنامج
      المكافآت باستخدام الخدمات. بموجب هذه شروط الخدمة هذه، لا تتحمل
      تي باي أي التزام أو مسؤولية عن أي أخطاء أو سهو في أي محتوى في
      الخدمات. تحتفظ تي باي بالحق، ولكن لا تتحمل أي مسؤولية، في تعديل
      أو رفض نشر أو إزالة أي محتوى، سواء كليا أو جزئيا، يكون وفقا
      لتقديرها الخاص والمطلق مكروها أو خاطئا أو غير قانوني أو احتيالي
      أو خلاف ذلك بما ينتهك شروط الخدمة هذه.
    </li>
  </ol>

  <h3>توافر الخدمة</h3>
  <p class="mt-2">
    تعمل تي باي لضمان توافر الخدمة على مدار 24 ساعة في اليوم لمدة 7
    أيام في الاسبوع. ومع ذلك، قد يتعذر في بعض الأحيان الوصول إلى حسابك
    و / أو يتم قطع خدمة الدفع بالنسبة للصيانة والتحديثات والإصلاحات في
    حالات الطوارئ أو نتيجة لإخفاق روابط ومعدات الاتصالات. أنت توافق
    على أن تي باي لن تكون مسؤولة تجاهك عن أي عدم توافر أو تعليق أو وقف
    لخدمة الدفع. تحتفظ تي باي بالحق في رفض تقديم الخدمة لك في أي وقت
    ولأي سبب بدون إشعار.
  </p>

  <h3>
    إخلاء المسؤولية عن السلع أو الخدمات المدفوع مقابلها باستخدام تي
    باي
  </h3>
  <p class="mt-2">
    لسنا مسؤولين ولا نتحمل أية مسؤولية عن أية سلع أو خدمات يتم شراؤها
    أو سداد ثمنها من خلال خدمة تي باي، بما في ذلك ما إذا كان المنتج أو
    الخدمة التي تم شرائها غير آمنة أو لم يتم تسليمها أو في حالة كونها
    محطمة أو مختلفة عمّا تم عرضه أو خلاف ذلك على النحو الذي لا يلبي
    احتياجاتك أو توقعاتك. إذا ظهرت مشكلة في المنتج أو الخدمة التي قمت
    بشرائها من تاجر تجزئة خارجي (على سبيل المثال، تاجر)، فأنت بحاجة
    إلى حل المشكلة بشكل مباشر مع التاجر.
  </p>

  <h3>إخلاء المسؤولية عن الضمانات وتحديد المسؤولية</h3>
  <p class="mt-2">
    أنت تقر وتوافق على أن السلع التي تم شراؤها باستخدام تي باي هي
    مقدمة من قبل أطراف ثالثة وليس من قبل تي باي، وأن تي باي لا تتحمل
    أي مسؤولية من أي نوع تجاهك فيما يتعلق بهذه السلع أو المتعلقة
    بتسليمها. خدمة الدفع التي تقدمها تي باي هي على أساس "الحالة
    الراهنة" و"حسبما هو متوافر". لا تقدم تي باي أي إقرارات أو ضمانات
    من أي نوع، سواء كانت صريحة أو ضمنية، بما في ذلك - على سبيل المثال
    لا الحصر - الضمانات الضمنية الخاصة بقابلية التسويق والملاءمة لغرض
    معين أو فيما يتعلق بتشغيل خدمة الدفع أو المعلومات أو المحتوى أو
    المواد أو المنتجات (بما في ذلك البرامج) أو الخدمات المشمولة أو
    المتاحة لك خلاف ذلك من خلال خدمة الدفع. أنت توافق بشكل صريح على
    أنك مسؤول بمفردك عن استخدامك لخدمة الدفع.
  </p>
  <p>
    لا تضمن تي باي أن خدمة الدفع أو الاتصالات الإلكترونية المرسلة من
    تي باي خالية من الفيروسات أو المكونات الضارة الأخرى. لن تكون السوق
    المفتوحة مسؤولة عن أية أضرار من أي نوع والتي تنشأ عن استخدام خدمة
    تي باي أو عن أي معلومات أو محتوى أو مواد أو منتجات (بما في ذلك
    البرامج) أو الخدمات المشمولة أو المتاحة لك خلاف ذلك من خلال خدمة
    الدفع، بما في ذلك - على سبيل المثال لا الحصر - الأضرار المباشرة
    وغير المباشرة والعرضية والعقابية والتبعية.
  </p>

  <h3>التعويض</h3>
  <p class="mt-2">
    أنت توافق على التعويض والدفاع ودرأ الأذى عن تي باي والشركات
    التابعة لها ومسؤوليها ومدرائها وموظفيها ووكلائها وخلفائها
    والمتنازل لهم من وضد كافة المطالبات والالتزامات والخسائر والنفقات
    والأضرار والتكاليف، بما في ذلك على - سبيل المثال لا الحصر - أتعاب
    المحاماة المعقولة الناتجة عن (1) انتهاك أو خرق شروط الخدمة هذه من
    جانبك، أو (2) أي نشاط متعلق بالوصول إلى استخدامك لحسابك المسجل أو
    جهاز هاتفك المحمول (بما في ذلك على سبيل المثال لا الحصر الإهمال أو
    السلوك غير المشروع) من قبلك أو من قبل أي شخص آخر يصل إلى حسابك
    المسجل أو يستخدمه أو باستخدام خدمة الدفع من خلال جهازك المحمول أو
    باستخدام رقم هاتفك المحمول.
  </p>

  <h3>إبراء ذمة تي باي</h3>
  <p class="mt-2">
    إذا كان لديك خلاف مع شركة الهاتف المحمول الخاصة بك أو التاجر، فأنت
    تعفي تي باي بموجب شروط الخدمة هذه وتعفي كذلك الشركات التابعة لها
    ومسؤوليها ومدرائها وموظفيها ووكلائها وخلفائها والمتنازل لهم من أي
    وجميع المطالبات والطلبات والالتزامات والخسائر والأضرار أيا كان
    نوعها وطبيعتها والتي تنشأ عن أو المرتبطة بأي شكل من الأشكال بهذه
    الخلافات.
  </p>

  <h3>السياسات والتعديلات والبطلان الجزئي</h3>
  <p class="mt-2">
    نحتفظ بالحق في إجراء تغييرات على خدمة الدفع والسياسات وهذه الشروط
    والأحكام في أي وقت وبدون إشعار. استمرارك في استخدام خدمة الدفع بعد
    هذا التعديل يشكّل موافقتك على الشروط والأحكام المعدلة. في حالة عدم
    قبولك لأي تعديل تم إجراؤه في هذه الشروط والأحكام، فإن الحل الوحيد
    والحصري هو إغلاق حسابك. في حالة اعتبار أي من هذه الشروط باطلا أو
    غير قابل للنفاذ لأي سبب من الأسباب، سيتم اعتبار هذا الشرط قابلا
    للفصل ولن يؤثر على صلاحية ونفاذ أي من الشروط المتبقية.
  </p>

  <h3>الاتصال</h3>
  <p class="mt-2">
    برجاء الاتصال بنا إذا كان لديك أي أسئلة بخصوص الشروط والأحكام.
  </p>
  <a href="mailto:support@tpaymobile.com"> support@tpaymobile.com </a>
  `,
};
